import ConfigFile from "../../../datasets/config_file";
import RetirementSavingsDataset from "../datasets/retirement_savings_dataset";
import calculateJobSalary from "../../../objects/AssetsExpenses/calculate_job_salary";

export const calculateMoodRetirementScores = (currentMoodPoints, currentCash, currentSavings, 
    totalInvestments, assetTable, gameDate) => {
         
    let maxMoodPoints = ConfigFile.gameStartItems.maxMoodPoints;
    let moodPercent = (+currentMoodPoints/+maxMoodPoints) * 100;
    if (currentMoodPoints > 50000){
        currentMoodPoints = 50000;
    }
    let moodRotation = ((9/5 * moodPercent) - 90).toFixed(2);
    if (moodRotation > 90){
        moodRotation = 90;
    }else{
        if (moodRotation < -90){
            moodRotation = -90;
        }
    }
    
    let emojiURL = ""
    if (moodRotation < -45){
        emojiURL = "./assets/moodFaceSad.png";
    }else{
        if (moodRotation >= -45 && moodRotation <= 45){
            emojiURL = "./assets/moodFaceIndifferent.png";
        }else{
            emojiURL = "./assets/moodFaceHappy.png";
        }
    }
    
    if (!currentSavings){
        currentSavings = 0;
    }
    let totalSavingsAmt = +currentCash + +currentSavings + totalInvestments;
    const annualSalary = calculateJobSalary(assetTable, gameDate, false, "annual");
    const salaryMultiplier = ConfigFile.gameBoard.retirementSalaryMultiplier;
    let totalRetirementAmt = +annualSalary * salaryMultiplier;
    const minimumSavings = ConfigFile.gameBoard.retirementMinAmt;
    if (totalRetirementAmt < minimumSavings){
        totalRetirementAmt = minimumSavings;
    }

    let savingsPercent = (totalSavingsAmt/totalRetirementAmt) * 100;
    if (savingsPercent > 100){
        savingsPercent = 100;
    }
    let retirementRotation = +((9/5 * savingsPercent) - 90).toFixed(2);
    if (retirementRotation > 90){
        retirementRotation = 90;
    }else{
        if (retirementRotation < -90){
            retirementRotation = -90;
        }
    }

    // retirementBase is a multiplier that is used to turn the percentages into a number 
    let retirementBase = ConfigFile.gameBoard.retirementBase;
    let retirementScore = (+savingsPercent * retirementBase).toFixed(0);
    let moodScore = (+moodPercent * +retirementBase).toFixed(0);
    let combinedScore = ((+retirementScore + +moodScore)/2).toFixed(0);

    let returnObj = {moodPercent: moodPercent, moodRotation: moodRotation, emojiURL: emojiURL,
        retirementPercent:  savingsPercent, retirementRotation: retirementRotation, totalSavings: totalSavingsAmt,
        salaryMultiplier: salaryMultiplier, minimumSavings: minimumSavings,
        totalRetirementAmt: totalRetirementAmt, annualSalary: annualSalary,  
        moodScore: moodScore, retirementScore: retirementScore, combinedScore: combinedScore};
    return returnObj
}

export default calculateMoodRetirementScores;